import type { Kpi } from '../../types/Kpi'
import { DashboardCard } from '../DashboardCard'
import { KpiButton } from '../KpiButton'

interface Props {
  kpi: Kpi
  showKpiActions?: boolean
  onClickTile: (kpi: Kpi, kpiColor?: string) => void
}

export const KpiTile = ({
  kpi,
  showKpiActions = false,
  onClickTile,
}: Props) => {
  const { statusText, total, red, amber, green } = kpi

  const onClick = (event: any, kpiColor?: string) => {
    event.stopPropagation()
    onClickTile(kpi, kpiColor)
  }

  return (
    <DashboardCard
      onClick={onClick}
      label={statusText}
      count={total}
      actions={
        showKpiActions && (
          <>
            {red > 0 && (
              <KpiButton color={'red'} count={red} onClick={onClick} />
            )}
            {amber > 0 && (
              <KpiButton color={'amber'} count={amber} onClick={onClick} />
            )}
            {green > 0 && (
              <KpiButton color={'green'} count={green} onClick={onClick} />
            )}
          </>
        )
      }
    />
  )
}
